import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "readdy_favorites_v1";
const EVENT_NAME = "readdy-favorites-changed";

function readFavorites(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === "string") : [];
  } catch {
    return [];
  }
}

function writeFavorites(list: string[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    // 本地存储不可用时静默降级
  }
  window.dispatchEvent(new Event(EVENT_NAME));
}

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>(() => readFavorites());

  useEffect(() => {
    const sync = () => setFavorites(readFavorites());
    window.addEventListener(EVENT_NAME, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT_NAME, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const isFavorite = useCallback((id: string) => favorites.includes(id), [favorites]);

  const toggleFavorite = useCallback((id: string) => {
    const current = readFavorites();
    const next = current.includes(id)
      ? current.filter((item) => item !== id)
      : [...current, id];
    writeFavorites(next);
    return next.includes(id);
  }, []);

  const removeFavorite = useCallback((id: string) => {
    const next = readFavorites().filter((item) => item !== id);
    writeFavorites(next);
  }, []);

  return { favorites, isFavorite, toggleFavorite, removeFavorite };
}